import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function StandOnScale(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M18 4a5.002 5.002 0 014.9 4h6.926a2 2 0 011.993 2.166l-1.666 20A2 2 0 0128.16 32H7.84a2 2 0 01-1.993-1.834l-1.666-20a2.002 2.002 0 011.827-2.16l.082-.004L13.1 8A5 5 0 0118 4zm.217 9.995L18 14a5 5 0 01-5-5H6.132l-.041.003c-.512.043-.9.463-.917.963l.003.117 1.667 20a1 1 0 00.878.91L7.84 31h20.32c.48 0 .886-.34.98-.8l.016-.117 1.667-20A1 1 0 0029.826 9H23a4.999 4.999 0 01-4.783 4.995zM21.5 28a.5.5 0 010 1h-7a.5.5 0 010-1h7zM18 5a3.999 3.999 0 00-.5 7.969V10.5a.5.5 0 011 0v2.469A4.001 4.001 0 0018 5z"></path>
    </IconSvg>
  );
}
